import apiServices from "../../../../services/apiServices";
import eventBus from "../../../main";
import volumes from "../../index";

export default {
  actions: {
    checkConnection(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      return apiServices
        .checkConn(value)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              return context.dispatch("transferToAnotherWallet");
            }
            let payload = {
              color: "error",
              right: "center",
              top: "top",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {})
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    checkToCharge(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      return apiServices
        .checkConn(value)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              const payload = {
                cellphone: this.cellphone,
                value: volumes.getters.getAmountToSet
              };
              return context.dispatch("chargeWithWallet", payload);
            }
            let payload = {
              color: "error",
              right: "center",
              top: "top",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {})
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    checkConnectionPay(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      const pin = {
        pin: value.pin
      };
      return apiServices
        .checkConn(pin)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              return context.dispatch("payService", value);
            }
            let payload = {
              color: "error",
              right: "center",
              top: "top",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {})
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  }
};
